jQuery.cookie = function(name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // CAUTION: Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + (options.path) : '';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};


	(function($){
		$(function(){
			
			if(location.hash.indexOf('debugon') != -1 || $.cookie('_debug') == 'true'){
				$.cookie('_debug','true')
				window._debug = true;
			}
			if(location.hash.indexOf('debugoff') != -1 && $.cookie('_debug') == 'true'){
				$.cookie('_debug',null);
			}


			var G = {
				active: false,
				/*
				 * Calls SimpleModal with appropriate options 
				 */
				init: function () {
					G.images = $("a[rel^='lightbox']");
					G.images.click(function () {
						G.current_idx = G.images.index(this);
						$(G.create()).modal({
							closeHTML: '',
							//overlayClose: true,
							overlayId: 'gallery-overlay',
							containerId: 'gallery-container',
							containerCss: {left:0, top:'2%', width:'100%'},
							opacity: 50,
							autoPosition: false,
							onOpen: G.open,
							onClose: G.close
						});

						return false;
					});
				},
				/*
				 * Creates the HTML for the viewer 
				 */
				create: function () {
					return $("<div id='gallery'> \
							<div id='gallery-image-container'> \
								<div id='gallery-meta-container'> \
									<div id='gallery-meta'> \
										<div id='gallery-info'><span id='gallery-title'></span><span id='gallery-pages'></span></div> \
										<div id='gallery-nav'><a href='#' id='gallery-nav-previous-link'>[&laquo; <u>P</u>rev]</a> <a href='#' id='gallery-nav-next-link'>[<u>N</u>ext &raquo;]</a></div> \
										<div id='gallery-close'><a href='#' class='simplemodal-close'>X</a></div> \
									</div> \
								</div> \
							    <!-- <div id='gallery-controls'> \
									<div id='gallery-previous'> \
										<a href='#' id='gallery-previous-link'>&laquo; <u>P</u>rev</a> \
									</div> \
									<div id='gallery-next'> \
										<a href='#' id='gallery-next-link'><u>N</u>ext &raquo;</a> \
									</div> \
								</div> -->\
							</div> \
						</div>");
				},
				/*
				 * SimpleModal callback to create the 
				 * viewer and open it with animations 
				 */
				open: function (d) {
					G.container = d.container[0];
					G.gallery = $('#gallery', G.container);
					G.image_container = $('#gallery-image-container', G.container);
					G.controls = $('#gallery-nav', G.container);
					G.next = $('#gallery-nav-next-link', G.container);
					G.previous = $('#gallery-nav-previous-link', G.container);
					G.meta_container = $('#gallery-meta-container', G.container);
					G.meta = $('#gallery-meta', G.container);
					G.title = $('#gallery-title', G.container);
					G.pages = $('#gallery-pages', G.container);

					d.data.fadeIn(100, function () {
					// load the first image
						G.display();
					});

					d.container.fadeIn(100);
					d.overlay.fadeIn(100);
				
				},
				/*
				 * SimpleModal callback to close the 
				 * viewer with animations
				 */
				close: function (d) {
					var self = this;
					G.meta.fadeOut(function () {
					});
					G.image_container.fadeOut(300, function () {
					});
					d.data.fadeOut(300, function () {
					});
					d.container.fadeOut(300, function () {
					});
					d.overlay.fadeOut(300, function () {
						self.close(); // or $.modal.close();	
					});
					G.unbind();
				},
				/*
				 * Display the previous/next image 
				 */
				browse: function (link) {
					G.current_idx = $(link).is('#gallery-nav-next-link') ? (G.current_idx + 1) : (G.current_idx - 1);
					G.display();
				},
				/* display the requested image and animate the height/width of the container */
				display: function () {
					//G.controls.hide();
					G.meta.fadeIn(100, function () {
						G.meta_container.fadeOut(100);
						G.image_container.fadeOut(100, function () {
							$('#gallery-image', G.container).remove();

							var img = new Image();
							img.onload = function () {
								G.load(img);
							};
							img.onerror = function(e){
								alert(e);
							}
							img.src =  G.images.eq(G.current_idx).attr('href');

							if (G.current_idx !== 0) {
								// pre-load prev img
								var p = new Image();
								p.src = G.images.eq(G.current_idx - 1).attr('href');
							}
							if (G.current_idx !== (G.images.length - 1)) {
								// pre-load next img
								var n = new Image();
								n.src = G.images.eq(G.current_idx + 1).attr('href');
							}
						});
					});
				},
				load: function (img) {
					var i = $(img);
					i.attr('id', 'gallery-image').addClass('simplemodal-close').css({maxWidth:$(window).width()*.9,maxHeight:$(window).height()*.88}).hide().appendTo('body');
					var h = i.outerHeight(true) + G.meta.height(),
						w = i.outerWidth(true),
						aspect = h/w;

					if (G.gallery.height() !== h || G.gallery.width() !== w) {
						G.gallery.animate(
							{height: h, width: w},
							100,
							function () {
								G.show(i);
							}
						);
					}
					else {
						G.show(i);
					}
				},
				/* 
				 * Show the image and then the controls and meta 
				 */
				show: function (img) {
					img.show();
					G.showControls();
					G.showMeta();
					G.image_container.append(img).fadeIn('fast', function () {
					});
				},
				/*
				 * Show the image controls; previous and next 
				 */
				showControls: function () {
					//G.next.hide().removeClass('disabled');
					//G.previous.hide().removeClass('disabled');
					G.next.removeClass('disabled');
					G.previous.removeClass('disabled');
					G.unbind();

					if (G.current_idx === 0) {
						G.previous.addClass('disabled');
					}
					if (G.current_idx === (G.images.length - 1)) {
						G.next.addClass('disabled');
					}
					//G.controls.show();

					$('a', G.controls).bind('click.gallery', function () {
						G.browse(this);
						return false;
					});
					$(document).bind('keydown.gallery', function (e) {
						if (!G.active) {
							if ((e.keyCode === 37 || e.keyCode === 80) && G.current_idx !== 0) {
								G.active = true;
								G.previous.trigger('click.gallery');
							}
							else if ((e.keyCode === 39 || e.keyCode === 78) && G.current_idx !== (G.images.length - 1)) {
								G.active = true;
								G.next.trigger('click.gallery');
							}
						}
					});
					
					
					/*
					$('div', G.controls[0]).hover(
						function () {
							var self = this,
								l = $(self).find('a:not(.disabled):not(:animated)');
							if (l.length > 0) {
								l.fadeIn(100);
							}
						},
						function () {
							$(this).find('a').fadeOut(100);
						}
					);
					*/
					
				},
				/*
				 * Show the image meta; title, image x of x and the close X 
				 */
				showMeta: function () {
					G.title.html(G.images.eq(G.current_idx).find('img').attr('title'));
					G.pages.empty();
					$('<a>[Add to basket]</a>').attr('href', '#').click(function(){$('form#cartadd').submit();}).appendTo(G.pages)
					$('<span> ' + (G.current_idx + 1) + '/' + G.images.length + '</span>').appendTo(G.pages);
					G.meta_container.fadeIn(100)
					G.meta.show();
					G.active = false;	
				},
				/*
				 * Unbind gallery control events 
				 */
				unbind: function () {
					$('a', G.controls[0]).unbind('click.gallery');
					$(document).unbind('keydown.gallery');
					$('div', G.controls[0]).unbind('mouseenter mouseleave');
				}
			};
			G.init();


			
    		
		})
	})(jQuery);

